export default __webpack_public_path__ + "assets/cec-component.e31fc7c3.svg";